import React from 'react';
import webRTC from "./WebRTC";
function doPulse(elem) {
    elem.onanimationend = (_) => {
        if (elem.classList.contains("pulse"))
            elem.classList.remove("pulse");
        if (elem.classList.contains("pulse2"))
            elem.classList.remove("pulse2");
    };
    if (elem.classList.contains("pulse")) {
        elem.classList.remove("pulse");
        elem.classList.add("pulse2");
    }
    else if (elem.classList.contains("pulse2")) {
        elem.classList.remove("pulse2");
        elem.classList.add("pulse");
    }
    else {
        elem.classList.add("pulse");
    }
}
function setupInteraction(canvases, viewerContext, onImageFlag) {
    var clickCount = 0;
    var clickTimer;
    const eventListenerCallback = (e) => {
        e.preventDefault();
        clickCount++;
        if (clickCount <= 1) {
            clickTimer = setTimeout(() => {
                clickCount = 0;
            }, 400);
        }
        else if (clickCount == 2) {
            canvases.forEach(doPulse);
            onImageFlag(viewerContext.current);
            clearTimeout(clickTimer);
            clickCount = 0;
        }
    };
    canvases.forEach((canvas) => {
        canvas.addEventListener("mousedown", eventListenerCallback);
    });
    return eventListenerCallback;
}
function teardownInteraction(canvases, callback) {
    canvases.forEach((canvas) => {
        canvas.removeEventListener("mousedown", callback);
    });
}
const LiveTelepathology = ({ signalingClient, peerConnection, dataChannels, layoutConfig, canvasIds, onDroppedFrame, onImageFlag, onControlMessage, debugTeleStats }) => {
    const containerRef = React.useRef(null);
    const context = React.useRef(null);
    const viewerContext = React.useRef({
        currentFrame: 0,
        foundFirstFrame: false,
        dataStarted: false,
        stopped: false
    });
    React.useEffect(() => {
        if (!context.current) {
            let canvases = canvasIds.map((id) => {
                const canvas = document.getElementById(id);
                if (canvas instanceof HTMLCanvasElement) {
                    return canvas;
                }
                else {
                    return null;
                }
            }).filter((canvas) => canvas !== null);
            if (canvases.length === 0) {
                console.error("No valid canvases found with the provided canvas IDs.");
                return;
            }
            else if (canvases.length <= 1 && layoutConfig.isInForm) {
                console.error("Inform mode requires at least two canvases.");
                return;
            }
            webRTC.setupDataChannels(canvases, dataChannels, peerConnection, viewerContext, onDroppedFrame, onControlMessage, debugTeleStats);
            const interactionCallback = setupInteraction(canvases, viewerContext, onImageFlag);
            context.current = {
                interactionCallback,
                canvases
            };
        }
        return () => {
            if (context.current) {
                const { interactionCallback, canvases } = context.current;
                teardownInteraction(canvases, interactionCallback);
                context.current = null;
            }
            signalingClient.close();
            peerConnection.close();
        };
    }, [containerRef]);
    return React.createElement("div", { id: "viewer", className: "viewer", ref: containerRef });
};
export default LiveTelepathology;
